import {
    FaCreditCard,
    FaCcAmazonPay,
    FaCcAmex,
    FaCcApplePay,
    FaCcDinersClub,
    FaCcDiscover,
    FaCcJcb,
    FaCcMastercard,
    FaCcPaypal,
    FaCcStripe,
    FaCcVisa,
} from 'react-icons/fa'
import { FaTrash } from 'react-icons/fa'
import { useMemo } from 'react'
import { titleCase, zeroPad } from '@utils'
import cn from 'clsx'

export const CreditCardBrands = {
    AmazonPay: 'amazon',
    Amex: 'amex',
    ApplePay: 'applepay',
    DinersClub: 'dinersclub',
    Discover: 'discover',
    Jcb: 'jcb',
    Mastercard: 'mastercard',
    Paypal: 'paypal',
    Stripe: 'stripe',
    Visa: 'visa',
}

const brandIcons = {
    [CreditCardBrands.AmazonPay]: FaCcAmazonPay,
    [CreditCardBrands.Amex]: FaCcAmex,
    [CreditCardBrands.ApplePay]: FaCcApplePay,
    [CreditCardBrands.DinersClub]: FaCcDinersClub,
    [CreditCardBrands.Discover]: FaCcDiscover,
    [CreditCardBrands.Jcb]: FaCcJcb,
    [CreditCardBrands.Mastercard]: FaCcMastercard,
    [CreditCardBrands.Paypal]: FaCcPaypal,
    [CreditCardBrands.Stripe]: FaCcStripe,
    [CreditCardBrands.Visa]: FaCcVisa,
}

/**
 * @param {Object} props StripeCard
 * @returns {JSX.Element}
 * @constructor
 */
const CreditCard = ({
    className,
    card,
    onRemoveCardClick,
}) => {
    
    const BrandIcon = useMemo(() => (
        brandIcons[card.brand] || FaCreditCard
    ), [card.brand])
    
    return (
        
        <div
            className={cn('CreditCard',
                'relative m-auto w-72 p-5 rounded-xl bg-gradient-to-r',
                'from-base-200 to-base-300/50 text-base-content shadow-2xl', className)}>
            
            <div className="flex justify-between">
                <div className="">
                    <p className="font-light">
                        {titleCase(card.brand, true)} Ending In
                    </p>
                    <p className="tracking-more-wider font-medium">{card.last4}</p>
                </div>
                <BrandIcon className="text-4xl" />
            </div>
            
            <div className="pt-6 pb-1">
                <div className="flex justify-between content-end">
                    <div className="">
                        <p className="text-xs font-light">Expiring On</p>
                        <p className="text-base font-medium tracking-widest">
                            {zeroPad(card.exp_month)}/{card.exp_year}
                        </p>
                    </div>
                    
                    <div className="flex flex-col justify-end items-end content-end">
                        <button
                            className="btn btn-square btn-ghost hover:text-error btn-sm"
                            onClick={() => onRemoveCardClick(card)}>
                            <FaTrash />
                        </button>
                    </div>
                </div>
            
            </div>
        
        </div>
        
    )
    
}

export default CreditCard
